import { from, Observable } from 'rxjs';

export function urlToFile(url: string, fileName: string): Observable<File> {
  return from(
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new File([blob], fileName, { type: blob.type || 'image/png' }),
      ),
  );
}
